import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from 'react-toastify';

const InspectionReportModal = ({
  show,
  handleClose,
  selectedId,
  fetchQualityCheckList,
  fetchUpcommingList
}) => {
  const [upcommingqualitychecks, setUpcommingqualitychecks] = useState(null);
  const [formData, setFormData] = useState({
    actual_quantity: "",
    quantity_rejected: "",
    notes: "",
  });
  const checklists = {
    "Degreaser report check": [
      "Surface Degreased Properly",
    ],
    "Grit blasting report": [
      "First Blasting Surface check",
      "Second Blasting Surface check",
    ],
    "Viscosity check": [
      "Viscosity of 205(5)",
      "Viscosity of 6411(5)",
    ],
    "Film thickness check": [
      "Film thickness of 205(5)",
      "Film thickness of 6411(5)",
    ]
  };
  const checklistKeyMap = {
    "Surface Degreased Properly": "surface_degreased_properly",
    "First Blasting Surface check": "first_blasting_surface_check",
    "Second Blasting Surface check": "second_blasting_surface_check",
    "Viscosity of 205(5)": "viscosity_of_205_5",
    "Viscosity of 6411(5)": "viscosity_of_6411_5",
    "Film thickness of 205(5)": "film_thickness_of_205_5",
    "Film thickness of 6411(5)": "film_thickness_of_6411_5",
  };

  useEffect(() => {
    if (show && upcommingqualitychecks) {
      const type = upcommingqualitychecks?.quality_issues?.check_type;
      if (type && checklists[type]) {
        const checklistObj = {};
        checklists[type].forEach(item => {
          checklistObj[item] = false;
        });
        setFormData(prev => ({ ...prev, ...checklistObj }));
      }
    }
  }, [show, upcommingqualitychecks]);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const fetchUpcommingqualitychecks = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(
        `${config.API}/supervisor/upcommingqualitychecks/${selectedId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response?.data?.success) {
        setUpcommingqualitychecks(response.data);
      } else {
        setUpcommingqualitychecks(null);
      }
    } catch (err) {
      console.error(err);
      setUpcommingqualitychecks(null);
    }
  };
  useEffect(() => {
    if (show && selectedId) {
      fetchUpcommingqualitychecks();
    }
  }, [show, selectedId]);

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }
    const type = upcommingqualitychecks?.quality_issues?.check_type;
    const checklistFields = checklists[type] || [];
    const payload = {
      product_id: upcommingqualitychecks?.quality_issues?.product_id,
      actual_quantity: Number(formData.actual_quantity) || 0,
      nc_quantity: Number(formData.quantity_rejected) || 0,
      notes: formData.notes,
    };
    checklistFields.forEach(field => {
      const backendKey = checklistKeyMap[field];
      if (backendKey) {
        payload[backendKey] = !!formData[field];
      }
    });
    try {
      const response = await axios.post(
        `${config.API}/supervisor/inspectionreport/${selectedId}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        toast.success("Inspection report submitted successfully!");
        fetchQualityCheckList();
        fetchUpcommingList();
        handleClose();
        setFormData({ actual_quantity: "", quantity_rejected: "", notes: "" });
      } else {
        toast.error(response.data.message || "Submission failed!");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };

  if (!upcommingqualitychecks) return null;
  const type = upcommingqualitychecks?.quality_issues?.check_type;
  const checklistFields = checklists[type] || [];

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className='font_family'>
      <Modal.Body className="p-5">
        <strong className="fs-4">Inspection Report</strong>
        <div className="p-3 mb-4 bg-light mt-4">
          <Row>
            <Col>ID: <strong>{upcommingqualitychecks?.quality_issues?.product?.product_code}</strong></Col>
            <Col>Product: <strong>{upcommingqualitychecks?.quality_issues?.product?.name}</strong></Col>
          </Row>
          <Row>
            <Col>Type: <strong>{type}</strong></Col>
          </Row>
        </div>
        <div className="p-3 mb-4 bg-light">
          <strong>Inspection Checklist</strong>
          {checklistFields.map((field, idx) => (
            <Form.Check
              key={idx}
              label={field}
              name={field}
              checked={formData[field] || false}
              onChange={handleChange}
            />
          ))}
        </div>
        <Row className="mb-3">
          <Col md={4}><strong>Actual Quantity</strong></Col>
          <Col md={8}>
            <Form.Control
              type="number"
              name="actual_quantity"
              value={formData.actual_quantity}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}><strong>Quantity of NC</strong></Col>
          <Col md={8}>
            <Form.Control
              type="number"
              name="quantity_rejected"
              value={formData.quantity_rejected}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col md={4}><strong>Notes</strong></Col>
          <Col md={8}>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              value={formData.notes}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
        <Button variant="dark" onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InspectionReportModal;